import React from "react";

const rows = [
  {
    others: "Le agenzie creative vendono idee",
    onsports: "Noi progettiamo sistemi di impatto integrati",
  },
  {
    others: "Le concessionarie vendono spazi",
    onsports: "Noi costruiamo piattaforme di crescita",
  },
  {
    others: "Le consulenze tradizionali producono piani che restano nei cassetti",
    onsports: "Noi accompagniamo dall'idea alla misurazione",
  },
];

const ComparisonTable = () => {
  return (
    <div className="border border-galactico/20" data-testid="comparison-table">
      <div className="grid grid-cols-2">
        <div className="p-5 md:p-7 border-b border-galactico/20 border-r-2 border-r-lime">
          <span className="font-condensed uppercase tracking-widest text-sm text-mandrogni">
            Gli altri
          </span>
        </div>
        <div className="p-5 md:p-7 border-b border-galactico/20">
          <span className="font-condensed uppercase tracking-widest text-sm text-lime">
            OnSports
          </span>
        </div>
      </div>
      {rows.map((r, i) => (
        <div key={i} className="grid grid-cols-2">
          <p
            className={`p-5 md:p-7 text-[15px] md:text-[1.0625rem] opacity-80 border-r-2 border-r-lime ${
              i < rows.length - 1 ? "border-b border-galactico/15" : ""
            }`}
          >
            {r.others}
          </p>
          <p
            className={`p-5 md:p-7 text-[15px] md:text-[1.0625rem] font-medium ${
              i < rows.length - 1 ? "border-b border-galactico/15" : ""
            }`}
          >
            {r.onsports}
          </p>
        </div>
      ))}
    </div>
  );
};

export default ComparisonTable;
